export const ForceToTopDom = () => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}



// WEBPACK FOOTER //
// ./src/utils/helpers/scrollToTop.js